import React, { useState } from "react";
import axios from "axios";
import { useContext } from "react";
import AppContext from "../../../context/AppContext";
import Swal from "sweetalert2";

const TIME_SLOTS = [
  { label: "09:00 AM", value: "09:00:00" },
  { label: "09:30 AM", value: "09:30:00" },
  { label: "10:00 AM", value: "10:00:00" },
  { label: "10:30 AM", value: "10:30:00" },
  { label: "11:00 AM", value: "11:00:00" },
  { label: "11:30 AM", value: "11:30:00" },
  { label: "12:00 PM", value: "12:00:00" },
  { label: "12:30 PM", value: "12:30:00" },
  { label: "01:00 PM", value: "13:00:00" },
  { label: "01:30 PM", value: "13:30:00" },
  { label: "02:00 PM", value: "14:00:00" },
  { label: "02:30 PM", value: "14:30:00" },
  { label: "03:00 PM", value: "15:00:00" },
  { label: "03:30 PM", value: "15:30:00" },
  { label: "04:00 PM", value: "16:00:00" },
  { label: "04:30 PM", value: "16:30:00" },
  { label: "05:00 PM", value: "17:00:00" },
];

const S = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(43,43,43,0.45)",
    backdropFilter: "blur(3px)",
    zIndex: 1000,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  box: {
    background: "#fff",
    borderRadius: 24,
    padding: "36px 32px 32px",
    width: "100%",
    maxWidth: 460,
    boxShadow: "0 20px 60px rgba(232,135,157,0.18)",
    position: "relative",
    margin: 16,
  },
  closeBtn: {
    position: "absolute",
    top: 14,
    right: 18,
    background: "none",
    border: "none",
    fontSize: "1.5rem",
    color: "#8A94A6",
    cursor: "pointer",
    lineHeight: 1,
  },
  badge: {
    display: "inline-block",
    background: "#F6D6DE",
    color: "#E8879D",
    fontSize: "0.72rem",
    fontWeight: 700,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    padding: "3px 12px",
    borderRadius: 20,
    marginBottom: 8,
  },
  discount: {
    fontSize: "1.9rem",
    fontWeight: 900,
    color: "#E8879D",
    margin: "0 0 4px",
    lineHeight: 1,
  },
  title: {
    fontSize: "1.2rem",
    fontWeight: 800,
    color: "#2B2B2B",
    margin: "0 0 16px",
  },
  divider: {
    border: "none",
    borderTop: "1.5px solid #f0f4f6",
    margin: "0 0 20px",
  },
  label: {
    display: "block",
    fontSize: "0.78rem",
    fontWeight: 700,
    color: "#5F6B7A",
    marginBottom: 6,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
  },
  inputReadOnly: {
    width: "100%",
    padding: "11px 15px",
    border: "1.5px solid #f0c0cc",
    borderRadius: 12,
    fontSize: "0.92rem",
    color: "#E8879D",
    background: "#F6D6DE",
    fontWeight: 700,
    outline: "none",
    boxSizing: "border-box",
    cursor: "default",
  },
  input: {
    width: "100%",
    padding: "11px 15px",
    border: "1.5px solid #e8f0f4",
    borderRadius: 12,
    fontSize: "0.92rem",
    color: "#2B2B2B",
    background: "#f9fcfd",
    outline: "none",
    boxSizing: "border-box",
  },
  select: {
    width: "100%",
    padding: "11px 15px",
    border: "1.5px solid #e8f0f4",
    borderRadius: 12,
    fontSize: "0.92rem",
    color: "#2B2B2B",
    background: "#f9fcfd",
    outline: "none",
    boxSizing: "border-box",
    appearance: "none",
  },
  row: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 14,
    marginTop: 16,
  },
  claimBtn: {
    width: "100%",
    padding: "13px",
    background: "linear-gradient(135deg,#E8879D 0%,#d4607a 100%)",
    color: "#fff",
    border: "none",
    borderRadius: 30,
    fontSize: "0.95rem",
    fontWeight: 700,
    cursor: "pointer",
    marginTop: 22,
    letterSpacing: "0.02em",
  },
};
const ClaimDealModal = ({ deal, onClose, onClaimed }) => {
  const { baseUrl } = useContext(AppContext);
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [loading, setLoading] = useState(false);

const createDeal = () => {
  // Validation
  if (!date || !time) {
    Swal.fire({
      icon: "warning",
      title: "Missing Information",
      text: "Please select both date and time.",
      confirmButtonColor: "#E8879D",
    });
    return;
  }

  const customer = JSON.parse(localStorage.getItem("customer"));

  if (!customer || !customer.id) {
    Swal.fire({
      icon: "error",
      title: "Login Required",
      text: "Please login before claiming a deal.",
      confirmButtonColor: "#E8879D",
    });
    return;
  }

  setLoading(true);

  console.log("Deal ID:", deal.id);
  console.log("Customer ID:", customer.id);

  const formData = new FormData();

  formData.append("esdeal_id", deal.id);
  formData.append("escustomer_id", customer.id);
  formData.append("appointment_date", date);
  formData.append("appointment_time", time);

  axios
    .post(
      `${baseUrl}/customer/appointment/createAppointment`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )

    .then((response) => {
      console.log(response.data);

      Swal.fire({
        icon: "success",
        title: "Deal Claimed!",
        text: "Your deal has been claimed successfully.",
        confirmButtonColor: "#E8879D",
      }).then(() => {
          onClaimed?.();
        onClose();
      });
    })

    .catch((error) => {
      console.log(error);

      Swal.fire({
        icon: "error",
        title: "Something Went Wrong",
        text:
          error.response?.data?.message ||
          "Unable to claim the deal. Please try again.",
        confirmButtonColor: "#E8879D",
      });
    })

    .finally(() => {
      setLoading(false);
    });
};
  return (
    <div
      style={S.overlay}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div style={S.box}>
        {/* Close Button */}
        <button style={S.closeBtn} onClick={onClose}>
          &times;
        </button>

        {/* Header */}
        {deal.tag && <span style={S.badge}>{deal.tag}</span>}
        <p style={S.discount}>{deal.discount}</p>
        <h2 style={S.title}>{deal.title}</h2>
        <hr style={S.divider} />

        {/* Deal - read only */}
        <div>
          <label style={S.label}>Deal</label>
          <input
            style={S.inputReadOnly}
            type="text"
            value={deal.title}
            readOnly
          />
        </div>

        {/* Date & Time */}
        <div style={S.row}>
          <div>
            <label style={S.label}>Date</label>
            <input
              style={S.input}
              type="date"
              value={date}
              min={new Date().toISOString().split("T")[0]}
              onChange={(e) => setDate(e.target.value)}
            />
          </div>
          <div>
            <label style={S.label}>Time</label>
            <select
              style={S.select}
              value={time}
              onChange={(e) => setTime(e.target.value)}
            >
              <option value="">Pick a time</option>

              {TIME_SLOTS.map((slot) => (
                <option key={slot.value} value={slot.value}>
                  {slot.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Submit */}
        <button style={S.claimBtn} onClick={createDeal} disabled={loading}>
          {loading ? "Claiming..." : "Claim Deal"}
        </button>
      </div>
    </div>
  );
};

export default ClaimDealModal;
